// WiseSage front-end interactions
import './mouse-tracker.js';

// Intersection Observer for reveal animations
(function(){
	if (!('IntersectionObserver' in window)) {
		document.querySelectorAll('.reveal').forEach(el=>el.classList.add('reveal-visible'));
		return;
	}
	const io = new IntersectionObserver((entries)=>{
		entries.forEach(e=>{
			if(e.isIntersecting){
				e.target.classList.add('reveal-visible');
				io.unobserve(e.target);
			}
		});
	}, { rootMargin: '0px 0px -10% 0px', threshold: .15 });
	document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
})();

// Minor performance: mark JS-ready
document.documentElement.classList.add('ws-js');

// Parallax Scrolling Effects
(function(){
	const hero1 = document.querySelector('[data-parallax-hero]');
	const heroTitle = document.querySelector('.ws-hero-title');
	const heroHeading = document.querySelector('#hero-content-heading'); // Black bar heading
	const missionText = document.querySelector('.mission-text'); // Mission statement
	const hero2 = document.querySelector('[data-parallax-reveal]');
	const hero2Bg = document.querySelector('[data-parallax-layer]');
	const body = document.documentElement;

	if (!hero1 || !hero2 || !hero2Bg || !heroTitle) return;

	// Header height for fade calculations
	const headerHeight = 80;

	// Throttle scroll events for performance
	let ticking = false;

	const updateParallax = () => {
		const scrollY = window.pageYOffset || window.scrollY;
		const viewportHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;

		// Hero 1 - Slow parallax scroll
		const hero1Rect = hero1.getBoundingClientRect();
		const hero1Progress = Math.max(0, Math.min(1, (viewportHeight - hero1Rect.top) / (viewportHeight + hero1Rect.height)));
		const hero1Offset = scrollY * 0.5; // Slow parallax rate
		hero1.style.transform = `translateY(${hero1Offset}px)`;

		// Fade out hero title/logo as it scrolls up toward header
		const fadeStartPoint = 0;
		const fadeEndPoint = viewportHeight - headerHeight;
		const fadeDistance = fadeEndPoint - fadeStartPoint;
		const scrollProgress = Math.max(0, Math.min(1, (scrollY - fadeStartPoint) / fadeDistance));
		const titleOpacity = 1 - scrollProgress;
		heroTitle.style.opacity = titleOpacity.toFixed(3);

		// Fade out hero heading (in black bar) as it approaches header
		if (heroHeading) {
			const headingRect = heroHeading.getBoundingClientRect();
			// Start fading when heading is 400px from header, fully faded at header
			const headingFadeStart = headerHeight + 400;
			const headingFadeEnd = headerHeight;
			const headingFadeDistance = headingFadeStart - headingFadeEnd;
			const headingProgress = Math.max(0, Math.min(1, (headingFadeStart - headingRect.top) / headingFadeDistance));
			const headingOpacity = 1 - headingProgress;
			heroHeading.style.opacity = headingOpacity.toFixed(3);
		}

		// Fade out mission statement text as it approaches header
		const missionTexts = document.querySelectorAll('.mission-text');
		missionTexts.forEach((missionText) => {
			const missionRect = missionText.getBoundingClientRect();
			// Start fading when text is 400px from header, fully faded at header
			const missionFadeStart = headerHeight + 400;
			const missionFadeEnd = headerHeight;
			const missionFadeDistance = missionFadeStart - missionFadeEnd;
			const missionProgress = Math.max(0, Math.min(1, (missionFadeStart - missionRect.top) / missionFadeDistance));
			const missionOpacity = 1 - missionProgress;
			missionText.style.opacity = missionOpacity.toFixed(3);
		});

		// Fade out tree hero text as it approaches top of viewport
		const treeText = document.querySelector('.hero-tree-text');
		if (treeText) {
			const treeRect = treeText.getBoundingClientRect();
			// Start fading when text is 400px from top of viewport, fully faded before header
			const treeFadeStart = 400;
			const treeFadeEnd = headerHeight + 50; // Fade out completely before reaching header
			const treeFadeDistance = treeFadeStart - treeFadeEnd;
			const treeProgress = Math.max(0, Math.min(1, (treeFadeStart - treeRect.top) / treeFadeDistance));
			const treeOpacity = 1 - treeProgress;
			treeText.style.opacity = treeOpacity.toFixed(3);
		}

		// Hero 2 - Reveal when scrolled into view (no parallax)
		const hero2Rect = hero2.getBoundingClientRect();
		const hero2InView = hero2Rect.top < viewportHeight * 0.8;

		if (hero2InView) {
			hero2.classList.add('is-visible');
			// Removed parallax effect on background layer
		}

		// First hero background fade: fade out when scrolling down, fade back in near bottom
		const fadeOutPoint = viewportHeight * 1.5; // Fade out after 1.5 viewports
		const fadeInPoint = documentHeight - viewportHeight * 2; // Fade in at bottom 2 viewports

		let heroOpacity = 1;

		if (scrollY < fadeOutPoint) {
			// Fade out as we scroll past hero
			heroOpacity = 1 - Math.min(1, scrollY / fadeOutPoint);
		} else if (scrollY > fadeInPoint) {
			// Fade back in near bottom
			const fadeInProgress = (scrollY - fadeInPoint) / (documentHeight - fadeInPoint - viewportHeight);
			heroOpacity = Math.min(1, fadeInProgress);
		} else {
			heroOpacity = 0;
		}

		body.style.setProperty('--hero-bg-opacity', heroOpacity.toFixed(3));

		ticking = false;
	};

	const requestTick = () => {
		if (!ticking) {
			requestAnimationFrame(updateParallax);
			ticking = true;
		}
	};

	// Initial update
	updateParallax();

	// Update on scroll and resize
	window.addEventListener('scroll', requestTick, { passive: true });
	window.addEventListener('resize', () => {
		updateParallax();
		requestTick();
	}, { passive: true });
})();

// Starfield Effect - Generate flickering stars in black sections
(function(){
	const starfields = document.querySelectorAll('.starfield');

	if (starfields.length === 0) return;

	// Random number generator with range
	const random = (min, max) => Math.random() * (max - min) + min;

	// White color shades (from dim to bright)
	const whiteShades = [
		'rgba(255, 255, 255, 0.3)',
		'rgba(255, 255, 255, 0.5)',
		'rgba(255, 255, 255, 0.7)',
		'rgba(255, 255, 255, 0.9)',
		'rgba(240, 240, 255, 0.6)', // Slight blue tint
		'rgba(255, 255, 240, 0.6)', // Slight warm tint
		'#ffffff'
	];

	starfields.forEach(section => {
		regenerateStarsForSection(section);
	});

	// Regenerate stars on window resize (debounced)
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			starfields.forEach(section => {
				// Remove existing stars
				section.querySelectorAll('.star').forEach(star => star.remove());
				// Regenerate stars for this section
				regenerateStarsForSection(section);
			});
		}, 1000);
	}, { passive: true });

	// Function to regenerate stars for a specific section
	function regenerateStarsForSection(section) {
		// Calculate star density based on section size
		const rect = section.getBoundingClientRect();
		const area = rect.width * rect.height;
		const starCount = Math.floor(area / 5000); // ~1 star per 5000 square pixels

		// Generate stars
		for (let i = 0; i < starCount; i++) {
			const star = document.createElement('div');
			star.className = 'star';

			// Random position
			const left = random(0, 100);
			const top = random(0, 100);
			star.style.left = `${left}%`;
			star.style.top = `${top}%`;

			// Random size (1-4px, with bias toward smaller)
			const sizeRoll = Math.random();
			let size;
			if (sizeRoll < 0.7) {
				size = random(1, 2); // 70% small stars
			} else if (sizeRoll < 0.9) {
				size = random(2, 3); // 20% medium stars
			} else {
				size = random(3, 4.5); // 10% large stars
				star.classList.add('star-glow'); // Add glow to largest stars
			}
			star.style.setProperty('--star-size', `${size}px`);

			// Random white shade
			const shade = whiteShades[Math.floor(Math.random() * whiteShades.length)];
			star.style.background = shade;

			// Random opacity (0.3 to 1.0)
			const opacity = random(0.3, 1.0);
			star.style.setProperty('--star-opacity', opacity);

			// Random flicker duration (3-8 seconds)
			const duration = random(3, 8);
			star.style.setProperty('--flicker-duration', `${duration}s`);

			// Random delay to stagger animations (0-5 seconds)
			const delay = random(0, 5);
			star.style.setProperty('--flicker-delay', `${delay}s`);

			section.appendChild(star);
		}
	}
})();

// Typewriter Effect for Mission Statements
(function(){
	const missionSection = document.querySelector('.mission-statement-section');
	const missionTexts = document.querySelectorAll('.mission-text');

	if (!missionSection || missionTexts.length === 0) return;

	// Track typing state to prevent race conditions
	let isTypingInProgress = false;
	let currentTypingTimeout = null;

	// Enhanced typewriter function with natural timing and completion callback
	function typeWriter(element, text, onComplete = null) {
		element.textContent = ''; // Clear existing text
		element.style.opacity = '1'; // Make sure it's visible

		let i = 0;
		const baseSpeed = 35; // Slightly slower for better readability

		function typeNextChar() {
			if (i < text.length) {
				// Type 1-2 characters at once for efficiency while maintaining typing effect
				const charsToType = Math.min(2, text.length - i);
				element.textContent += text.substr(i, charsToType);
				i += charsToType;

				// Natural typing variations
				let speed = baseSpeed;

				// Pause longer at punctuation
				const lastChar = text.charAt(i - 1);
				if (lastChar === '.' || lastChar === '!' || lastChar === '?') {
					speed = baseSpeed * 3; // Longer pauses at sentence end
				} else if (lastChar === ',' || lastChar === ':' || lastChar === ';') {
					speed = baseSpeed * 2; // Medium pauses for commas
				} else {
					// Add slight randomness to make it feel more human
					speed = baseSpeed + (Math.random() * 10 - 5); // ±5ms variation
				}

				currentTypingTimeout = setTimeout(typeNextChar, speed);
			} else {
				// Typing complete, call callback if provided
				currentTypingTimeout = null;
				if (onComplete) {
					setTimeout(onComplete, 200); // Brief pause before next action
				}
			}
		}

		// Start typing after a brief delay
		currentTypingTimeout = setTimeout(typeNextChar, 150);
	}

	// Function to start the complete typing sequence
	function startTypingSequence() {
		if (isTypingInProgress) return; // Prevent multiple concurrent sequences

		isTypingInProgress = true;

		// Clear any existing timeout
		if (currentTypingTimeout) {
			clearTimeout(currentTypingTimeout);
			currentTypingTimeout = null;
		}

		if (missionTexts.length >= 2) {
			const firstParagraph = missionTexts[0];
			const secondParagraph = missionTexts[1];

			const firstText = firstParagraph.getAttribute('data-original-text') || firstParagraph.textContent.trim();
			const secondText = secondParagraph.getAttribute('data-original-text') || secondParagraph.textContent.trim();

			// Store original texts if not already stored
			if (!firstParagraph.hasAttribute('data-original-text')) {
				firstParagraph.setAttribute('data-original-text', firstText);
				secondParagraph.setAttribute('data-original-text', secondText);
			}

			// Clear both paragraphs immediately so neither shows full text during typing
			firstParagraph.textContent = '';
			secondParagraph.textContent = '';

			// Start first paragraph, then second when complete
			typeWriter(firstParagraph, firstText, () => {
				// First paragraph complete, start second paragraph
				typeWriter(secondParagraph, secondText, () => {
					// Both paragraphs complete
					isTypingInProgress = false;
				});
			});
		} else {
			// Fallback for single paragraph
			missionTexts.forEach((element) => {
				const originalText = element.getAttribute('data-original-text') || element.textContent.trim();
				if (!element.hasAttribute('data-original-text')) {
					element.setAttribute('data-original-text', originalText);
				}
				element.textContent = ''; // Clear immediately
				typeWriter(element, originalText, () => {
					isTypingInProgress = false;
				});
			});
		}
	}

	// Intersection Observer to trigger typing when section enters viewport
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting && !entry.target.dataset.typingTriggered) {
				// Mark as triggered to prevent re-triggering
				entry.target.dataset.typingTriggered = 'true';

				// Start the typing sequence
				startTypingSequence();

				// Stop observing once triggered
				observer.unobserve(entry.target);
			}
		});
	}, {
		rootMargin: '0px 0px -50px 0px', // Trigger when section is 50px from entering viewport
		threshold: 0.1
	});

	// Start observing the mission section
	observer.observe(missionSection);

	// Re-trigger typewriter on window resize (show full text immediately)
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			// Clear any ongoing typing
			if (currentTypingTimeout) {
				clearTimeout(currentTypingTimeout);
				currentTypingTimeout = null;
			}
			isTypingInProgress = false;

			missionTexts.forEach((element) => {
				const originalText = element.getAttribute('data-original-text');
				if (originalText) {
					element.textContent = originalText; // Show full text immediately on resize
					element.classList.add('typing-complete'); // Center the text
				}
			});
		}, 1000);
	}, { passive: true });
})();

// Email Obfuscation - Prevent email scraping
(function(){
	// Function to construct email from parts
	function constructEmail(user, domain) {
		return user + '@' + domain;
	}

	// Email data - encoded to make it harder for scrapers
	const emails = {
		'footer-contact': ['hello', 'example.com'],
		'home-support': ['support', 'wisesage.io'],
		'contact-support': ['support', 'wisesage.ai'],
		'contact-info': ['info', 'wisesage.ai']
	};

	// Replace obfuscated email links
	document.querySelectorAll('[data-email]').forEach(link => {
		const emailKey = link.getAttribute('data-email');
		if (emails[emailKey]) {
			const [user, domain] = emails[emailKey];
			const email = constructEmail(user, domain);
			link.href = 'mailto:' + email;
			// Update text content for links that should display the email
			if (emailKey === 'contact-support' || emailKey === 'contact-info') {
				link.textContent = email;
			}
		}
	});
})();

// Website Analytics Tracking
(function(){
	// Generate or get session ID
	function getSessionId() {
		let sessionId = localStorage.getItem('ws_session_id');
		if (!sessionId) {
			sessionId = 'ws_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
			localStorage.setItem('ws_session_id', sessionId);
		}
		return sessionId;
	}

	// Track page view
	function trackPageView() {
		const data = {
			session_id: getSessionId(),
			page_url: window.location.pathname + window.location.search,
			page_title: document.title,
			referrer: document.referrer || null,
			event_type: 'pageview',
			event_data: {
				user_agent: navigator.userAgent,
				language: navigator.language,
				viewport: {
					width: window.innerWidth,
					height: window.innerHeight
				},
				timestamp: Date.now()
			}
		};

		// Send tracking data
		fetch('/api/analytics/track', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		}).catch(err => {
			// Silently fail - don't break the site if analytics fails
			console.warn('Analytics tracking failed:', err);
		});
	}

	// Track user interactions (clicks, scrolls)
	function trackInteraction(eventType, eventData = {}) {
		const data = {
			session_id: getSessionId(),
			page_url: window.location.pathname + window.location.search,
			event_type: eventType,
			event_data: {
				...eventData,
				timestamp: Date.now()
			}
		};

		fetch('/api/analytics/track', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		}).catch(() => {
			// Silently fail
		});
	}

	// Track page view on load
	trackPageView();

	// Track scroll depth
	let maxScrollDepth = 0;
	window.addEventListener('scroll', () => {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const scrollDepth = Math.round((scrollTop + windowHeight) / documentHeight * 100);

		if (scrollDepth > maxScrollDepth && scrollDepth >= 25) { // Track at 25%, 50%, 75%, 100%
			maxScrollDepth = Math.floor(scrollDepth / 25) * 25;
			trackInteraction('scroll', { depth: maxScrollDepth });
		}
	}, { passive: true });

	// Track time spent on page
	let pageStartTime = Date.now();
	window.addEventListener('beforeunload', () => {
		const timeSpent = Math.round((Date.now() - pageStartTime) / 1000);
		if (timeSpent >= 10) { // Only track if spent at least 10 seconds
			trackInteraction('time', { duration_seconds: timeSpent });
		}
	});

	// Track clicks on important elements
	document.addEventListener('click', (e) => {
		const target = e.target.closest('a, button, [data-track]');
		if (target) {
			const eventData = {
				element_type: target.tagName.toLowerCase(),
				element_text: target.textContent?.trim().substring(0, 50) || '',
				element_href: target.href || '',
				element_class: target.className || ''
			};

			if (target.hasAttribute('data-track')) {
				eventData.track_type = target.getAttribute('data-track');
			}

			trackInteraction('click', eventData);
		}
	}, { passive: true });

})();

// Initialize mouse tracking for analytics
if (typeof MouseTracker !== 'undefined') {
    window.mouseTracker = new MouseTracker({
        enabled: false,
        recordSession: true,
        throttleDelay: 500,
        batchSize: 50,
        sendInterval: 30000,
        sessionSendInterval: 15000
    });
}
